<style lang="scss" scoped>
@import '$vars';
.wrapper {
  width: 100%;
}

.tooltip {
  display: inline;
  position: relative;
}
.tooltip:hover:after{
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  background: #444;
  border-radius: 8px;
  color: #fff;
  content: attr(title);
  margin: -82px auto 0;
  font-size: 16px;
  padding: 13px;
  width: 220px;
}
.tooltip:hover:before{
  border: solid;
  border-color: #444 transparent;
  border-width: 12px 6px 0 6px;
  content: "";
  left: 45%;
  bottom: 30px;
  position: absolute;
}

.card-header {
  flex-direction: row-reverse;
  justify-content: space-between;
  padding: 0.3rem 0.8rem 0.8rem;
}
</style>

<template>
  <div class="wrapper"> <!-- trocar essas classes com o "main". esta deverá  ter só "wrapper" -->
    <dr-accordion-wrapper
      v-if="office.id"
      :appointments="filteredEvents"
      :daysView="`${daysView}`"
      :loading="loading"
      :agendaSettings="agendaSettings"
      :selectedDate.sync="currentDate"
    />

    <div class="agenda-view">
      <article :ref="'agendaView'">
        <template>
          <div
            :key="`s${appointments.length}`"
            data-active="false"
            id="settingsMenu"
            class="dropdown"
          >
            <ul class="menu">
              <li
                class="menu-item clickable"
                @click="blockModal = true"
              >
                Bloquear agenda
              </li>

              <li
                class="menu-item clickable"
                @click="googleModal = true"
              >
                Sincronizar com Google
              </li>
            </ul>
          </div>
        </template>

        <div class="TOUR_DUMMY" style="position: absolute; outine: none !important; opacity: 0; right: 40%; top: 20%"><span></span></div>

        <agenda-block
          v-if="office.id"
          :active="blockModal"
          @cancel="blockModal = false"
          @blocked="init"
        />

        <transition name="fade" mode="out-in">
          <agenda-unblock
            v-if="showAgendaUnblock"
            :data="agendaUnblockData"
            @close="showAgendaUnblock = false"
            @reload="init"
          />
        </transition>

        <google-sync
          v-if="office.id"
          :active="googleModal"
          @cancel="googleModal = false"
        />

        <!-- Agendamento Simples -->
        <dr-appointment-simple
          v-if="office.id && appointmentActive"
          :current-date.sync="appointmentData.date"
          :appointment.sync="appointmentData.edit"
          @cancel="appointmentActive = false"
        />
        <!-- /Agendamento Simples -->

        <header class="card-header flex-space_between" />

        <component
          :is="fn_IS_MOBILE() ? 'DrMobileAgendaSettings' : 'DrAgendaSettings'"
          :daysView="`${daysView}`"
          :sliderStyle="sliderStyle"
          :agendaViewOptions="agendaViewOptions"
          :agendaWorkingHours="agendaWorkingHours"
          :hasAppIntegration="hasAppIntegration"
          :agendaInterval="agendaInterval"
          :currentWeek="currentWeek"
          :currentDate="currentDate"
          :showCalendar="showCalendar"
          @add-week="addWeek($event)"
          @add-days="addDays($event)"
          @slider="sliderValue = $event"
          @method="agendaSettingsMethod($event)"
          @toggled="agendaSettingsToggled($event)"
        >
          <div>
            <dr-calendar
             v-show="showCalendar"
             v-model.lazy="currentDate"
             @change="showCalendar = false"
            />
          </div>
        </component>

        <section class="card-body">
          <transition-group name="fade" mode="out-in" tag="div" v-if="loaded && daysView !== 'list'">
            <dr-agenda
              :key="'agenda'"
              :selected-date.sync="currentDate"
              :settings.sync="agendaSettings"
              :events.sync="agendaEvents"
              @placedEvents="filteredEvents = $event"
            />
          </transition-group>

          <transition-group name="fade" mode="out-in" tag="div" v-if="loaded && daysView === 'list'">
            <dr-agenda-lista
              key="agenda-lista"
              :selected-date.sync="currentDate"
              @event-callback="eventCallback"
            />
          </transition-group>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DrAgenda, DrCalendar } from 'cm2tech-vue-calendar'
import EventBus from '@/globals/eventBus'
import DrAppointmentSimple from '@/components/modals/agenda/appointmentSimple'
import agendaBlock from '@/components/modals/agenda/agendaBlock'
import agendaUnblock from '@/components/modals/agenda/agendaUnblock'
import accordionWrapper from '@/components/layout/accordionWrapper'
import googleSync from '@/components/modals/googleSync'
import DrAgendaLista from '@/components/layout/agenda/agendaLista'
import DrAgendaSettings from '@/components/layout/agenda/agendaSettings'
import DrMobileAgendaSettings from '@/components/layout/mobile/mobileAgendaSettings'

export default {
  components: {
    'drAccordionWrapper': accordionWrapper,
    agendaBlock,
    agendaUnblock,
    googleSync,
    DrAgenda,
    DrCalendar,
    DrAgendaLista,
    DrAppointmentSimple,
    DrAgendaSettings,
    DrMobileAgendaSettings
  },

  name: 'agendaView',

  data () {
    const agendaViewOptions = [
      {
        name: 'Dia',
        daysView: 1
      },
      {
        name: 'Semana',
        daysView: this.fn_IS_MOBILE() ? 3 : 7
      },
      {
        name: 'Lista',
        daysView: 'list'
      }
    ]

    return {
      scrollToTime: true,
      daysView: 7,
      agendaView: 'agendaWeek',
      doctor: null,
      loaded: false,
      loading: true,
      accordionEvents: [],
      filteredEvents: [],
      appointmentActive: true,
      agendaBlock: [],
      daysBlocked: [],
      highlightedDays: [],
      appointments: [],
      query: null,
      calendarOpts: {
        sameDay: 'YYYY-MM-DD',
        nextDay: 'YYYY-MM-DD',
        nextWeek: 'YYYY-MM-DD',
        lastDay: 'YYYY-MM-DD',
        lastWeek: 'YYYY-MM-DD',
        sameElse: 'YYYY-MM-DD'
      },
      blockModal: false,
      googleModal: false,
      today: this.$moment(),
      currentDate: null,
      showCalendar: false,
      showSlider: false,
      sliderValue: {
        value: [0, 24]
      },
      agendaWorkingHours: { start: 0, finish: 24 },
      agendaInterval: null,
      agendaListener: null,
      appointmentData: {
        date: this.$moment().toISOString(),
        edit: null
      },
      agendaViewOptions,
      showAgendaUnblock: false,
      agendaUnblockData: {}
    }
  },

  computed: {
    ...mapGetters({
      doctorOffices: 'getOffices',
      office: 'getCurrentOffice',
      appIntegration: 'getAppIntegration',
      isCredentialExpired: 'getNewCertifierCredentialRequired'
    }),

    hasAppIntegration () {
      return this.fn_IS_DOCTOR() &&
        this.appIntegration &&
        this.appIntegration['is_active']
    },

    agendaSettings () {
      let start = (
        this.office &&
        typeof this.office['agenda_view_interval'] === 'object' &&
        ('start' in this.office['agenda_view_interval']) &&
        this.office['agenda_view_interval'].start
      )
        ? this.office['agenda_view_interval'].start
        : this.sliderValue[0]

      let finish = (
        typeof this.office['agenda_view_interval'] === 'object' &&
        ('finish' in this.office['agenda_view_interval']) &&
        this.office['agenda_view_interval'].finish
      )
        ? this.office['agenda_view_interval'].finish
        : this.sliderValue[1]

      start = parseInt(start, 10)
      finish = parseInt(finish, 10)

      const agendaSettings = {
        interval: this.appointmentInterval,
        start: this.fn_IS_MOBILE() ? '01:00' : `${String(start).padStart(2, '0')}:00`,
        end: this.fn_IS_MOBILE() ? '24:00' : `${String(finish).padStart(2, '0')}:00`,
        daysView: this.daysView,
        fn: this.eventCallback,
        fnEvent: this.eventCallback,
        scrollToTime: this.scrollToTime
      }

      return agendaSettings
    },

    appointmentInterval () {
      const interval = this.$moment(this.office['appointment_interval'])
      const startOfDay = this.$moment(interval).startOf('d')
      const minutes = this.$moment.duration(interval.diff(startOfDay)).asMinutes()

      const h = Math.floor(minutes / 60)
      const m = minutes % 60

      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    },

    currentWeek () {
      const week = this.$moment(this.currentDate).week()
      const year = this.$moment(this.currentDate).year()
      const startOfWeek = this.fn_IS_MOBILE() ? this.$moment(this.currentDate) : this.$moment().year(year).week(week).day(0).startOf('day')
      const endOfWeek = this.fn_IS_MOBILE() ? this.$moment(this.currentDate).add(2, 'd') : this.$moment().year(year).week(week).day(6).startOf('day')
      const label = `${startOfWeek.format('D')} ${startOfWeek.format('MMM')} - ${endOfWeek.format('D')} ${endOfWeek.format('MMM')}`

      return {
        week,
        startOfWeek,
        endOfWeek,
        label
      }
    },

    agendaEvents () {
      const newAppointments = this.appointments.map((a) => this.buildAgendaEventObject(a))

      return [...newAppointments, ...this.agendaBlockedDays]
    },

    agendaBlockedDays () {
      const filtered = this.daysBlocked.filter((day) => {
        const start = this.$moment(day.start)
        const end = this.$moment(day.end)

        const isOfficeBlocked = day.office
          ? 'id' in day.office && day.office.id === this.office.id
          : true

        return isOfficeBlocked &&
          this.$moment(start).isSameOrAfter(this.currentWeek.startOfWeek.startOf('day')) &&
          this.$moment(end).isSameOrBefore(this.currentWeek.endOfWeek.endOf('day'))
      })

      return filtered
        ? filtered.map(
          (day) => {
            const interval = this.$moment(this.office['appointment_interval'])
            const startOfDay = this.$moment(interval).startOf('d')
            const minutes = this.$moment.duration(interval.diff(startOfDay)).asMinutes()

            const start = day.start
            const end = day.end

            const filteredEvents = this.daysBlocked.filter((d) => d.id === day.id)

            return this.buildAgendaEventObject({
              start,
              end,
              title: '',
              subtitle: '',
              className: ['blocked'],
              obj: {
                type: 'blocked',
                doctorOffice: day.office,
                id: day.id,
                start: filteredEvents[0].start,
                end: filteredEvents[filteredEvents.length - 1].end
              }
            })
          }
        )
        : []
    }
  },

  watch: {
    $route: function (next) {
      if (this.loaded) {
        this.fn_HIDE_PROGRESS()
      }
    },

    currentWeek: {
      deep: true,
      immediate: false,
      handler () {
        if (this.daysView !== 'list') {
          this.query = this.buildQuery()
          this.queryAgenda()
        }
      }
    },

    sliderValue: {
      deep: true,
      immediate: false,
      handler (next, prev) {
        // Antes de fazer a requisição na API
        // Verifica se os valores são diferentes dos anteriores
        // Para evitar requisições desnecessárias
        if (next[0] !== prev[0] || next[1] !== prev[1]) {
          this.updateAgendaWorkingHours(next[0], next[1])
          this.setAgendaInterval()
        }
      }
    },

    office: {
      deep: true,
      immediate: false,
      handler () {
        this.daysBlocked = null
        this.init()
        this.setAgendaWorkingHours()
      }
    }
  },

  created () {
    this.sliderStyle = {
      railStyle: {
        backgroundColor: '#D8D8D8',
        borderRadius: '3px',
        height: '5px'
      },
      processStyle: {
        backgroundColor: '#56BDD2'
      },
      dotStyle: {
        background: '#4a4a4a',
        boxShadow: 'none'
      },
      tooltipStyle: {
        backgroundColor: '#f1f5f4',
        borderColor: '#fff',
        color: '#4a4a4a',
        fontSize: '0.6rem',
        padding: '2px'
      }
    }

    EventBus.$on('agenda-reload', this.queryAgenda)
  },

  beforeMount () {
    if (this.doctorOffices.length > 0) {
      this.$moment.locale('pt-br')
      this.resizeAgenda()
      this.currentDate = this.$moment().toISOString()
      this.init()
      this.setAgendaWorkingHours()
    }
  },

  mounted () {
    this.appointmentActive = false
    window.addEventListener('resize', this.resizeAgenda)
  },

  updated () {
    this.$nextTick(() => {
      this.addEventHover()

      if (this.isCredentialExpired) {
        const agendaHeader = document.querySelectorAll('.dr-agenda__header')
        if (agendaHeader.length > 0) {
          agendaHeader[0].classList.add('dr-agenda__header--mt')
        }
      }
    })
  },

  methods: {
    init () {
      if (this.doctorOffices.length > 0) {
        this.loaded = false
        this.agendaView = 'agendaWeek' // setando semanal aqui por causa do tour
        this.appointments = []
        if (this.$refs.calendar) {
          this.$refs.calendar.fireMethod('destroy')
        }
        this.loading = true
        let arr = []
        this.highlightedDays = []
        for (let day of this.office.exclusive_days_agendas) {
          arr.push(day.day_of_week.substr(0, 3))
        }
        this.highlightedDays = arr

        // const statuses = [
        //   'EM ANDAMENTO',
        //   'NÃO COMPARECEU',
        //   'REALIZADO',
        //   'REAGENDADO',
        //   'PAGAMENTO NAO APROVADO'
        // ]
        this.getAgendaBlock()
          .then(() => {
            this.query = this.buildQuery()
            this.queryAgenda()
            // Desliga a configuração de scroll para o horário atual
            // setTimeout(() => (this.scrollToTime = false), 1000)
            this.scrollToTime = false
          })
          .catch(err => console.log('err\n', err))
      }
    },

    buildQuery () {
      const initialDate = this.currentWeek.startOfWeek.format('YYYY-MM-DD')
      const finalDate = this.currentWeek.endOfWeek.format('YYYY-MM-DD')

      const filters = [
        { query: 'filterGreatherEqual[a.appointmentStart]', value: `${initialDate} 00:00:00` },
        { query: 'filterLessEqual[a.appointmentStart]', value: `${finalDate} 23:59:59` },
        { query: 'itensPerPage', value: 'all' },
        { query: 'filterNotIn[a.status][]', value: 'reagendado' },
        { query: 'filterNotIn[a.status][]', value: 'não compareceu' },
        { query: 'filterNotIn[a.status][]', value: 'cancelado pelo médico' },
        { query: 'filterNotIn[a.status][]', value: 'cancelado pelo paciente' },
        { query: 'filterNotIn[a.status][]', value: 'pagamento não concluído' },
        { query: 'filterNotIn[a.status][]', value: 'pagamento não aprovado' }
      ]

      return filters.reduce((acc, item) => {
        if (item.value) {
          return `${
            acc === '?' ? `${acc}` : `${acc}&`
          }${item.query}=${item.value}`
        }

        return acc
      }, '?')
    },

    getDates (view, date) {
      let dates = {
        initial: null,
        final: null
      }
      if (date) {
        dates.initial = this.$moment(date)
          .startOf(view)
          .calendar(null, this.calendarOpts)
        dates.final = this.$moment(date).startOf(view)
        dates.final = view === 'week' ? dates.final.add(7, 'days') : dates.final.add(1, 'month')
        dates.final = dates.final.calendar(null, this.calendarOpts)
      } else {
        dates.initial = this.$moment()
          .startOf(view)
          .calendar(null, this.calendarOpts)
        dates.final = this.$moment()
          .endOf(view)
          .calendar(null, this.calendarOpts)
      }
      return dates
    },

    addAppointment (event, date, obj = null) {
      this.appointmentData.date = this.$moment(date).toISOString()
      this.appointmentData.edit = obj

      this.appointmentActive === true
        ? (this.appointmentActive = false)
        : (this.appointmentActive = true)
    },

    getAgendaBlock () {
      const url = `/${
        this.fn_IS_DOCTOR()
          ? 'doctor'
          : `secretary/doctor/${this.doctor.id}`
      }/agenda/agenda_block?itensPerPage=all`

      return this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const blocked = res.data.data
          const days = []

          blocked.forEach((block) => {
            const start = this.$moment(block['initial_date']).dayOfYear()
            const end = this.$moment(block['final_date']).dayOfYear()
            const diff = end - start

            if (diff > 0) {
              for (let i = 0; i <= diff; i++) {
                const end = this.$moment(block['final_date'])

                let newStart = i === 0
                  ? this.$moment(block['initial_date']).toISOString()
                  : this.$moment(block['initial_date']).add(i, 'day').startOf('day').toISOString()

                const agendaStartHour = this.$moment(newStart)
                  .startOf('day')
                  .add(this.agendaWorkingHours.start, 'hour')

                newStart = this.$moment(newStart).isBefore(agendaStartHour, 'hour') && this.$moment(end).isAfter(agendaStartHour, 'hour')
                  ? agendaStartHour.toISOString()
                  : newStart

                const newEnd = i === diff
                  ? this.$moment(block['final_date']).toISOString()
                  : this.$moment(block['initial_date']).add(i, 'day').endOf('day').toISOString()

                days.push({
                  id: block.id,
                  start: newStart,
                  end: newEnd,
                  office: block['doctor_office']
                })
              }
            } else {
              const start = this.$moment(block['initial_date'])
              const end = this.$moment(block['final_date'])

              const agendaStartHour = this.$moment(start)
                .startOf('day')
                .add(this.agendaWorkingHours.start, 'hour')

              const newStart = this.$moment(start).isBefore(agendaStartHour, 'hour') && this.$moment(end).isAfter(agendaStartHour, 'hour')
                ? agendaStartHour
                : start

              days.push({
                id: block.id,
                start: newStart.toISOString(),
                end: end.toISOString(),
                office: block['doctor_office']
              })
            }
          })

          this.daysBlocked = days
        })
    },

    agendaUnblock (doctorOffice, id) {
      const url = doctorOffice
        ? `/${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor_office/${doctorOffice.id}/agenda/agenda_block/${id}`
        : `/${this.fn_GET_PARENT_ROUTE(this.$route)}/agenda/agenda_block`

      this.fn_SHOW_PROGRESS()
      this.$http.delete(url, this.$store.getters.getAuthHeader)
        .then(() => {
          this.$store.dispatch('setModalConfirm')
          this.init()
        })
        .catch((err) => console.log('err \n', err))
        .finally(() => this.fn_HIDE_PROGRESS())
    },

    queryAgenda () {
      this.loading = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(
          `/${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor_office/${this.office.id}/agenda${this.query}`,
          this.$store.getters.getAuthHeader
        )
        .then((res) => this.queryTelemedicineAgenda(res.data.data))
        .then((res) => {
          this.appointments = []
          let patient = {}
          let arr = []
          for (let appointment of res) {
            appointment.special_patient.id
              ? (patient = appointment.special_patient)
              : (patient = appointment.user)
            appointment.patient = patient

            const classes = []

            if (appointment.status === 'REALIZADO') {
              classes.push('realizado')
            } else {
              if (appointment['medical_consultation_type']) {
                classes.push(
                  (/(exame|procedimento)/gi.test(String(appointment['medical_consultation_type'])))
                    ? 'exame'
                    : String(appointment['medical_consultation_type']).toLowerCase()
                )
              }
            }

            if (/aberto/gi.test(appointment.status) && /(particular(_\w+)?)|convenio/gi.test(appointment.type)) {
              classes.push('confirmado')
            }

            if (/drconecta/gi.test(appointment.type)) {
              classes.push('drconecta')
            }

            // Adiciona classe indicativa de pagamento realizado
            if (appointment['financial_statement']['is_consolidated']) {
              classes.push('pagamento-confirmado')
            }

            let subtitle = (/(exame|procedimento)/gi.test(String(appointment['medical_consultation_type'])))
              ? 'exame/procedimento'
              : String(appointment['medical_consultation_type']).toLowerCase()

            if (/cancelado/gi.test(appointment.status)) {
              classes.push('cancelado')
            }

            // Adiciona classe indicativa de consulta telemedicina
            if (/telemedicina/gi.test(appointment.type)) {
              const indexes = []
              indexes.push(classes.findIndex(c => c === 'exame'))
              indexes.push(classes.findIndex(c => c === 'retorno'))
              indexes.push(classes.findIndex(c => c === 'consulta'))

              indexes.forEach((i) => {
                if (i > -1) {
                  classes.splice(i, 1)
                }
              })

              classes.push('telemedicina')
            }

            arr.push({
              obj: appointment,
              start: appointment['appointment_start'],
              startDisplay: appointment['appointment_start'],
              endDisplay: appointment['appointment_finish'],
              end: appointment['appointment_finish'],
              title: patient.name,
              className: classes,
              subtitle
            })
          }

          this.accordionEvents = arr
          const appointments = this.filterOutEvents(arr)
          this.appointments = this.createOvernightEvents(appointments)
          this.loading = false
          this.loaded = true
          this.fn_HIDE_PROGRESS()
        })
        .catch(err => console.log(err))
    },

    queryTelemedicineAgenda (data) {
      const isOfficeFacetoface = /facetoface/gi.test(this.office.type)
      const telemedicineId = this.doctorOffices.some(o => /telemedicine/gi.test(o.type))
        ? this.doctorOffices.find(o => /telemedicine/gi.test(o.type)).id
        : false

      if (isOfficeFacetoface && telemedicineId) {
        return new Promise((resolve, reject) => {
          this.$http
            .get(`/${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor_office/${telemedicineId}/agenda${this.query}`,
              this.$store.getters.getAuthHeader
            )
            .then((res) => resolve([...data, ...res.data.data]))
        })
      }

      return data
    },

    addEventHover () {
      const events = document.querySelectorAll('.dr-agenda__event:not(.blocked)')
      events.forEach((event) => {
        if (event.offsetHeight < 38) {
          event.addEventListener('mouseenter', () => event.classList.add('full-height'))
          event.addEventListener('mouseleave', () => event.classList.remove('full-height'))
        }

        if (event.classList.contains('confirmado') && event.classList.contains('dr-agenda__event')) {
          this.showConfirmationTooltip(event)
        }
      })
    },

    showConfirmationTooltip (event) {
      const removeTooltip = () => {
        const tooltip = document.querySelectorAll('.confirmation-tooltip')
        if (tooltip.length > 0) {
          tooltip.forEach(t => t.parentNode.removeChild(t))
        }
      }

      const addTooltip = (event) => {
        const position = event.getBoundingClientRect()
        const tooltip = document.createElement('div')

        tooltip.classList.add('agenda-online-controls__tooltip', 'confirmation-tooltip')
        tooltip.innerText = 'Consulta confirmada pelo paciente'
        tooltip.style.display = 'none'
        tooltip.style.position = 'absolute'
        tooltip.style.bottom = 'calc(100% + 15px)'
        tooltip.style.left = `${(position.width / 2) - 17}px`
        tooltip.style.zIndex = '100'
        tooltip.style.transition = 'all ease 0.5s'

        event.appendChild(tooltip)

        setTimeout(() => (tooltip.style.display = 'block'), 100)
      }

      const datetime = event.getAttribute('datetime')
      const appointment = document.querySelector(`div[datetime='${datetime}'].confirmado`)

      this.$nextTick(() => {
        appointment.addEventListener('mouseenter', () => {
          removeTooltip()
          appointment.style.overflow = 'unset'
          addTooltip(appointment)
        })
        appointment.addEventListener('mouseleave', () => {
          appointment.style.overflow = 'hidden'
          removeTooltip()
        })
      })
    },

    addWeek (n = 0) {
      this.currentDate = this.fn_IS_MOBILE() ? this.$moment(this.currentDate).add(n * 3, 'd').toISOString() : this.$moment(this.currentDate).add(n, 'w').toISOString()
    },

    addDays (n = 0) {
      this.currentDate = this.$moment(this.currentDate).add(n, 'd').toISOString()
    },

    resizeAgenda () {
      if (this.daysView !== 'list') {
        if (this.fn_IS_MOBILE()) {
          this.daysView = 3
          this.agendaViewOptions[1].daysView = 3
        } else {
          this.daysView = 7
          this.agendaViewOptions[1].daysView = 7
        }
      }
    },

    updateAgendaWorkingHours () {
      const url = `/doctor/doctor_office/${this.office.id}/agenda_view_interval`
      const start = `${String(this.sliderValue[0]).padStart(2, '0')}:00:00`
      const finish = `${String(this.sliderValue[1]).padStart(2, '0')}:00:00`
      const data = {
        'agenda_view_interval': {
          agendaViewInterval: JSON.stringify({ start, finish })
        }
      }

      this.fn_SHOW_PROGRESS()
      this.$http({ url, method: 'put', data, headers: this.$store.getters.getAuthHeader.headers })
        .then(() => this.fn_GET_OFFICES(this.office.id))
        .catch(err => console.log('err \n', err))
        .finally(() => this.fn_HIDE_PROGRESS())
    },

    setAgendaWorkingHours () {
      const start = (
        typeof this.office['agenda_view_interval'] === 'object' &&
        ('start' in this.office['agenda_view_interval']) &&
        this.office['agenda_view_interval'].start
      )
        ? this.office['agenda_view_interval'].start
        : 0

      const finish = (
        typeof this.office['agenda_view_interval'] === 'object' &&
        ('finish' in this.office['agenda_view_interval']) &&
        this.office['agenda_view_interval'].finish
      )
        ? this.office['agenda_view_interval'].finish
        : 24
      this.agendaWorkingHours.start = this.fn_IS_MOBILE() ? 0 : parseInt(start, 10)
      this.agendaWorkingHours.finish = this.fn_IS_MOBILE() ? 24 : parseInt(finish, 10)
      this.sliderValue[0] = this.agendaWorkingHours.start
      this.sliderValue[1] = this.agendaWorkingHours.finish
      this.setAgendaInterval()
    },

    setAgendaInterval () {
      this.agendaInterval = `${String(this.sliderValue[0]).padStart(2, '0')}:00 às ${String(this.sliderValue[1]).padStart(2, '0')}:00`
    },

    filterOutEvents (events) {
      let filteredEvents = events
      const notAllowed = [
        /(cancelado)/i,
        /(não|nao)\s(aprovado)/i,
        /(não|nao)\s(compareceu)/i,
        /(pagamento)\s(não|nao)\s(concluído|concluido)/i
      ]

      // Filtra status não permitidos
      filteredEvents = filteredEvents.filter((e) => {
        return notAllowed
          .map(regex => regex.test(e.obj.status.trim()))
          .every(t => !t)
      })

      // Filtra agendamentos do tipo Dr. Conecta com status Aguardando pagamento
      filteredEvents = filteredEvents
        .filter((e) => {
          return !(/drconecta/i.test(e.obj.type) &&
            /(aguardando)\s?(pagamento)/i.test(e.obj.status))
        })

      return filteredEvents
    },

    createOvernightEvents (events) {
      const overnightEvents = []

      events.forEach((event) => {
        const startDate = this.$moment(event.start)
        const endDate = this.$moment(event.end)

        if (endDate.isAfter(startDate, 'day')) {
          const overnightEvent = { ...event }
          const overnightEventStart = this.$moment(overnightEvent.start)
          const overnightEventEnd = this.$moment(overnightEvent.end)
          const diff = overnightEventEnd.format('D') - overnightEventStart.format('D')

          for (let i = 1; i <= diff; i++) {
            const tempEvent = { ...overnightEvent }

            const agendaStartHour = this.$moment(startDate)
              .add(i, 'day')
              .startOf('day')
              .add(this.agendaWorkingHours.start, 'hour')

            const start = this.$moment(startDate)
              .add(i, 'day')
              .startOf('day')

            tempEvent.start = start.isBefore(agendaStartHour, 'hour')
              ? agendaStartHour.toISOString()
              : start.toISOString()

            tempEvent.end = i === diff
              ? overnightEventEnd.toISOString()
              : this.$moment(tempEvent.start)
                .endOf('day')
                .toISOString()

            overnightEvents.push(tempEvent)
          }
        }
      })

      return [...events, ...overnightEvents]
    },

    buildAgendaEventObject (event) {
      const startDisplay = 'startDisplay' in event ? this.$moment(event.startDisplay) : this.$moment()
      const endDisplay = 'endDisplay' in event ? this.$moment(event.endDisplay) : this.$moment()
      const start = this.$moment(event.start)
      const end = this.$moment(event.end)
      const duration = this.$moment.duration(end.diff(start)).asMinutes(0)
      const type = event.obj && event.obj.type !== 'blocked'
        ? String(event.obj['medical_consultation_type']).toLowerCase()
        : null
      let subtitle = String(
        type
          ? `${event.subtitle} \u2022 ${startDisplay.format('HH:mm')} - ${endDisplay.format('HH:mm')}`
          : ''
      )
      if (/(aguardando).?(pagamento)/i.test(event.obj.status)) {
        subtitle += `\naguardando pagamento`
      }

      const title = /(aguardando).?(pagamento)/i.test(event.obj.status)
        ? ''
        : event.title

      return {
        date: start.toISOString(),
        duration,
        className: event.className,
        title,
        subtitle,
        obj: event.obj ? event.obj : {}
      }
    },

    eventCallback (event, datetime, obj = null) {
      if (obj) {
        if (/(aguardando).?(pagamento)/i.test(obj.status || '') && /(healthplace)/i.test(obj.type || '')) {
          return
        }

        if (obj.type === 'blocked') {
          this.showAgendaUnblock = true
          this.agendaUnblockData = {
            id: obj.id,
            doctorOffice: {
              id: this.office.id,
              name: this.office.name
            },
            start: obj.start,
            end: obj.end
          }

          return
        }

        if (!('patient' in obj)) {
          obj['patient'] = obj['special_patient']
        }
      }

      if (this.$moment().isAfter(this.$moment(datetime), 'h') && !obj) {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Escolha uma data no futuro',
          size: 'sm',
          active: true
        })

        return
      }

      this.addAppointment(event, datetime, obj)
    },

    openAgendaOnline () {
      EventBus.$emit('open-agenda-online-controls')
    },

    agendaSettingsMethod (ev) {
      this[ev]()
    },

    agendaSettingsToggled (ev) {
      this[ev[0]] = ev[1]
    },

    unblockAllAgendas () {
      const unblock = () => {
        const url = `/${
          this.fn_IS_DOCTOR()
            ? 'doctor'
            : `secretary/doctor/${this.doctor.id}`
        }/agenda/agenda_block`

        this.$http
          .delete(url, this.$store.getters.getAuthHeader)
          .finally(() => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'As agendas de todos os seus consultórios foram desbloqueadas com sucesso.',
              size: 'sm',
              active: true
            })

            this.init()
          })
      }

      this.$store.dispatch('setModalConfirm', {
        title: 'Aviso',
        body: 'Deseja desbloquear as agendas em todos os seus consultórios?',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            unblock()
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    }
  }
}
</script>
